/**
 * Unregister old service workers left by Pushwoosh, and if they had a
 * subscription, unsubscribe from it and remove the device from the
 * server.
 *
 * @returns {Promise<void>} - A promise that resolves when the operation is
 * finished.
 */
export async function unregisterOldNotificationsSystem() {
    if ('serviceWorker' in navigator) {
        try {
            const registrations = await navigator.serviceWorker.getRegistrations();
            for (let registration of registrations) {
                if (registration.active?.scriptURL?.includes('pushwoosh')) {
                    const subscription = await registration.pushManager.getSubscription();
                    if (subscription) {
                        await subscription.unsubscribe();
                    }
                    await registration.unregister();
                }
            }
        } catch (error) {
            console.error('Error unregistering service workers:', error);
        }
    }
}
